module.exports = __webpack_public_path__ + "static/media/close.b7dc6c45.svg";